class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 600);

    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('input', this.debouncedSubmit);
    }
  }

  static initHistoryListener() {
    window.addEventListener('popstate', (event) => {
      const params = event.state?.searchParams || '';
      FacetFiltersForm.renderPage(params, null, false);
    });
  }

  static renderPage(searchParams, event, updateURL = true) {
    FacetFiltersForm.prevSearchParams = searchParams;

    FacetFiltersForm.showLoading();

    const sectionId = document.getElementById('product-grid')?.dataset.id;
    if (!sectionId) return;

    const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;

    fetch(url)
        .then((res) => res.text())
        .then((html) => {
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGrid(html);
          FacetFiltersForm.renderProductCount(html);

          FacetFiltersForm.hideLoading();

          if (updateURL) {
            history.pushState(
                { searchParams },
                '',
                `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`
            );
          }
        });
  }


  static renderFilters(html, event) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');

    const newFilters = parsed.querySelectorAll('#FacetFiltersForm .js-filter');
    const currentFilters = document.querySelectorAll('#FacetFiltersForm .js-filter');

    currentFilters.forEach((el) => {
      if (![...newFilters].some((n) => n.id === el.id)) el.remove();
    });

    newFilters.forEach((filter) => {
      const current = document.getElementById(filter.id);
      if (current) {
        current.innerHTML = filter.innerHTML;
      } else {
        document.querySelector('#FacetFiltersForm')?.appendChild(filter);
      }
    });

    FacetFiltersForm.renderActiveFacets(parsed);
  }

  static renderActiveFacets(parsed) {
    const active = parsed.querySelector('.active-facets-desktop');
    if (!active) return;

    document.querySelector('.active-facets-desktop').innerHTML = active.innerHTML;
  }


  static renderProductGrid(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = parsed.getElementById('ProductGridContainer');
    const grid = document.getElementById('ProductGridContainer');

    if (!newGrid || !grid) return;

    grid.innerHTML = newGrid.innerHTML;

    grid
        .querySelectorAll('.scroll-trigger')
        .forEach((el) => el.classList.add('scroll-trigger--cancel'));

    if (typeof fc_ChangeVariable === 'function') fc_ChangeVariable();
    if (typeof fc_LazyLoad === 'function') fc_LazyLoad();
  }


  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newCount = parsed.getElementById('ProductCount');
    const count = document.getElementById('ProductCount');

    if (!newCount || !count) return;

    count.innerHTML = newCount.innerHTML;
    count.classList.remove('loading');
  }


  static showLoading() {
    document.getElementById('ProductGridContainer')?.classList.add('loading');
    document.getElementById('ProductCount')?.classList.add('loading');
  }

  static hideLoading() {
    document.getElementById('ProductGridContainer')?.classList.remove('loading');
  }


  createSearchParams(form) {
    return new URLSearchParams(new FormData(form)).toString();
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const form = event.target.closest('form');
    if (!form) return;

    const params = this.createSearchParams(form);
    FacetFiltersForm.renderPage(params, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    const params = event.currentTarget.href.split('?')[1] || '';
    FacetFiltersForm.renderPage(params);
  }
}

if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
}

FacetFiltersForm.previousParams = '';
FacetFiltersForm.initHistoryListener();
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input[type=number]')
        .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.loadPriceRangeSlider();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.loadPriceRangeSlider();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input[type=number]');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  loadPriceRangeSlider() {
    const rangeInput = this.querySelectorAll('.facets__price .range-input input[type=range]'),
        priceInput = this.querySelectorAll('.facets__price input[type=number]'),
        range = this.querySelector('.facets__price .slider .progress');
    let priceGap = 1;

    priceInput.forEach((input) => {
      input.addEventListener("input", (e) => {
        let minPrice = Number(priceInput[0].value),
            maxPrice = Number(priceInput[1].value);

        if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
          if (e.target.className === "input-min") {
            rangeInput[0].value = minPrice;
            range.style.left = (minPrice / rangeInput[0].max) * 100 + "%";
          } else {
            rangeInput[1].value = maxPrice;
            range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
          }
        }
      });
    });

    rangeInput.forEach((input) => {
      input.addEventListener("input", (e) => {
        let minVal = Number(rangeInput[0].value),
            maxVal = Number(rangeInput[1].value);

        if (maxVal - minVal < priceGap) {
          if (e.target.className === "range-min") {
            rangeInput[0].value = maxVal - priceGap;
          } else {
            rangeInput[1].value = minVal + priceGap;
          }
        } else {
          priceInput[0].value = minVal;
          priceInput[1].value = maxVal;
          range.style.left = (minVal / rangeInput[0].max) * 100 + "%";
          range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
        }
      });
    });
  }
}
customElements.define('price-range', PriceRange);
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const link = this.querySelector('a');
    if (!link) return;

    link.setAttribute('role', 'button');
    link.addEventListener('click', (e) => {
      e.preventDefault();
      document
          .querySelector('facet-filters-form')
          .onActiveFilterClick(e);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

